<template>
  <div>
    <div class="headerTop">
      <div class="title">
        <!-- 数据结果比对 -->
        <!-- 最近两次PB -->
        Latest PB
      </div>
      <div class="buttonright">
        <el-button
          type="primary"
          @click="navBack"
          style="background: #304156;border-color:#304156"
          >Back</el-button
        >
      </div>
    </div>
    <div class="content" v-for="(item, index) in tableDate" :key="index">
      <div class="centerTop">
        {{ item.date }}
      </div>
      <div class="tableContent">
        <table border="1" cellpadding="10px" style="border: 1px solid #F4A274;">
          <!-- 单位行（excel第15行）：无边框/无底色、蓝色浮动文字，还原excel外观 -->
          <thead v-if="item.unitHeaderList && item.unitHeaderList.length">
            <tr>
              <th
                class="unit-cell"
                :colspan="indexuh == '1' ? '5' : '1'"
                v-for="(itemuh, indexuh) in item.unitHeaderList"
                :key="'u' + indexuh"
                :style="
                  indexuh > 1
                    ? 'min-width:50px;width:50px;max-width:100px;'
                    : 'min-width:200px;width:300px;'
                "
              >
                {{ itemuh }}
              </th>
            </tr>
          </thead>
          <thead style="background: #d7dcef;">
            <tr>
              <th
                :colspan="indexth == '1' ? '5' : '1'"
                v-for="(itemth, indexth) in item.oneHeaderList"
                :key="indexth"
                :style="
                  indexth > 1
                    ? 'min-width:50px;width:50px;max-width:100px;'
                    : 'min-width:200px;width:300px;'
                "
              >
                {{ itemth }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(itemtr, indextr) in item.oneTableVoList" :key="indextr">
              <td
                :colspan="indextd == 'oneTableData1' ? '6' : '1'"
                v-for="(itemtd, indextd) in itemtr"
                :key="indextd"
              >
                <span v-if="indextd != 'oneTableData1'">{{ itemtd }}</span>
                <span v-else>
                  <p
                    v-for="(itemn, indexn) in splieItemtd(itemtd)"
                    :key="indexn"
                    style="text-align: left;
    margin-block-start: 0;
    margin-block-end: 0;"
                  >
                    {{ itemn }}
                  </p>
                </span>
              </td>
            </tr>
          </tbody>
          <thead style="background: #d7dcef;">
            <!-- 第二个表头（excel第20行）：还原原始列布局 B,C,D:E,F,G,(空H),I,(空J),K,L -->
            <tr>
              <th>{{ item.twoHeaderList[0] }}</th>
              <th>{{ item.twoHeaderList[1] }}</th>
              <th colspan="2">{{ item.twoHeaderList[2] }}</th>
              <th>{{ item.twoHeaderList[3] }}</th>
              <th>{{ item.twoHeaderList[4] }}</th>
              <th></th>
              <th>{{ item.twoHeaderList[5] }}</th>
              <th></th>
              <th>{{ item.twoHeaderList[6] }}</th>
              <th>{{ item.twoHeaderList[7] }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ item.twoTableData1 }}</td>
              <td>{{ item.twoTableData2 }}</td>
              <td colspan="2">{{ item.twoTableData3 }}</td>
              <td>{{ item.twoTableData4 }}</td>
              <td>{{ item.twoTableData5 }}</td>
              <td></td>
              <td>{{ item.twoTableData6 }}</td>
              <td></td>
              <td>{{ item.twoTableData7 }}</td>
              <td>{{ item.twoTableData8 }}</td>
            </tr>
            <tr>
              <td colspan="11" style="text-align: left;">
                {{ item.twoTableData11 }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableDate: [],
      id: "",
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.init();
  },
  watch: {
    id(val) {
      this.init();
    },

    $route(to, from) {
      this.tableDate = [];
      this.id = this.$route.query.id;
      this.init();
      // 在这里进行数据的刷新操作
    },
  },
  methods: {
    navBack() {
      // this.$router.push({
      //     path: "/informationInquiry-index",
      // });
      this.$router.go(-1);
    },
    init() {
      // this.$router
      // console.log('$router', this.$route.query.id)
      if (!this.id) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http
        .get("/sys/sysstock/getCompareData?id=" + this.id)
        .then((res) => {
          loading.close();
          this.tableDate = res.data.data;
        })
        .catch((err) => {
          loading.close();
          this.navBack();
          this.$message({
            message: err,
            type: "error",
          });
        });
    },
    splieItemtd(data) {
      if(data){

      var list = null;
      list = data.split("\n");
      return list;
    }else{
      return []
    }

    },
  },
};
</script>

<style scoped>
.headerTop {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.headerTop .title {
  font-size: 24px;
}

.centerTop {
  margin: 30px;
  font-size: 20px;
  font-family: "Book Antiqua", "Helvetica Neue", Helvetica, "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.tableContent {
  margin: 0 30px;
}

.content {
  border-top: 1px solid #e2e2e2;
}

table {
  /* Book Antiqua 优先，未安装则回退系统默认字体栈 */
  font-family: "Book Antiqua", "Helvetica Neue", Helvetica, "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  width: 70vw;
  max-width: 75vw;
  /*居中*/
  /* margin: 0 auto; */
  /*边框*/
  /* border: 1px solid black; */

  border-collapse: collapse;
  /*设置背景颜色*/
  /* background-color: #bfa; */
}

/*
       * 设置边框
       */
td,
th {
  border: 1px solid black;
  min-width: 100px;
  line-height: 20px;
  text-align: center;
}

/* 单位行（excel第15行）：浮动蓝字，无底色，还原excel。
   顶/左/右用透明边框压过 table 的橙色外框（折叠边框中单元格边框优先级高于表格边框），
   底边留空，让下方表头行的黑色上边框正常显示 */
.unit-cell {
  border: 1px solid transparent !important;
  border-bottom: none !important;
  background: transparent !important;
  color: #5b9bd5;
  font-weight: normal;
}

/*
     * 设置隔行变色
     */
tbody > tr:nth-child(even) {
  /* background-color: rgb(235, 235, 235); */
}

/*
     * 鼠标移入到tr以后，改变颜色
     */
tr:hover {
  /* background-color: rgb(168, 168, 168); */
}
</style>
